module.exports = __webpack_public_path__ + "img/delete-icon.68159511.svg";